import api from '@/api_alv'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'

const DIR = "az/distributors"

const state = {
    distributors: [],
    selectedAzDistributors: [],
    azDistributorsSearch: "",
    selectedAzDistributorsVisibilityFilter: ['visible', 'hidden'],
    isAllSelectedAzDistributors: false,
    expandedAzDistributors: [],
    // Details
    azDistributorsDetails: {
        "addressRow1":          null,
        "addressRow2":          null,
        "alvId":                "ALV000000000AD",
        "city":                 null,
        "country":              null,
        "distributor":          null,
        "fullShippingAddress":  null,
        "zip":                  null
    },
    azDistributorsMetadata: {},
    azDistributorsFinance: {},
}

const getters = {
    getAzDistributors(state)                { return state.distributors },
    getSelectedAzDistributors(state)        { return state.selectedAzDistributors },
    getAzDistributorsSearch(state)          { return state.azDistributorsSearch },
    getSelectedAzDistributorsVisibilityFilter(state) { return state.selectedAzDistributorsVisibilityFilter },
    getIsAllSelectedAzDistributors(state)   { return state.isAllSelectedAzDistributors },
    getExpandedAzDistributors(state)        { return state.expandedAzDistributors },
    // Details
    getAzDistributorsDetails(state)                       { return state.azDistributorsDetails },
    getAzDistributorsDetailsAlvId(state)                  { return state.azDistributorsDetails.alvId },
    getAzDistributorsDetailsDistributor(state)            { return state.azDistributorsDetails.distributor },
    getAzDistributorsDetailsAddressRowOne(state)          { return state.azDistributorsDetails.addressRow1 },
    getAzDistributorsDetailsAddressRowTwo(state)          { return state.azDistributorsDetails.addressRow2 },
    getAzDistributorsDetailsZip(state)                    { return state.azDistributorsDetails.zip },
    getAzDistributorsDetailsCity(state)                   { return state.azDistributorsDetails.city },
    getAzDistributorsDetailsCountry(state)                { return state.azDistributorsDetails.country },
    getAzDistributorsDetailsFullShippingAddress(state)    { return state.azDistributorsDetails.fullShippingAddress },
    getAzDistributorsDetailsSalesCountry(state)           { return state.azDistributorsDetails.salesCountry },
    getAzDistributorsDetailsType(state)                   { return state.azDistributorsDetails.type },
    getAzDistributorsDetailsVisibility(state)             { return state.azDistributorsDetails.visibility },
    getAzDistributorsDetailsNotes(state)                  { return state.azDistributorsDetails.notes },
    getAzDistributorsDetailsShipmentNote(state)           { return state.azDistributorsDetails.shippingNote },
    // Metadata
    getAzDistributorsMetadata(state)                        { return state.azDistributorsMetadata },
    getAzDistributorsMetadataDetailsLanguage(state)         { return state.azDistributorsMetadata.language },
    getAzDistributorsMetadataDetailsCurrency(state)         { return state.azDistributorsMetadata.currency },
    getAzDistributorsMetadataDetailsFoundingDate(state)     { return state.azDistributorsMetadata.foundingDate },
    getAzDistributorsMetadataDetailsCustomerNumber(state)   { return state.azDistributorsMetadata.customerNumber },
    getAzDistributorsMetadataDetailsTasFromPricelist(state) { return state.azDistributorsMetadata.tasFromPricelist },
    getAzDistributorsMetadataDetailsWarehouseName(state)    { return state.azDistributorsMetadata.warehouseName },
    getAzDistributorsMetadataDetailsReturnFee(state)        { return state.azDistributorsMetadata.returnFee },
    getAzDistributorsMetadataDetailsReturnReserveCycle(state){ return state.azDistributorsMetadata.returnReserveCycle },
    getAzDistributorsMetadataDetailsReturnReservePercent(state){ return state.azDistributorsMetadata.returnReservePercent },
    getAzDistributorsMetadataDetailsFocFirstShipment(state) { return state.azDistributorsMetadata.focFirstShipment },
    getAzDistributorsMetadataDetailsFocAllShipments(state)  { return state.azDistributorsMetadata.focAllShipments },
    getAzDistributorsMetadataDetailsHandlingFee(state)  { return state.azDistributorsMetadata.handlingFee },
    getAzDistributorsMetadataDetailsDistributorReturnFee(state)  { return state.azDistributorsMetadata.returnFee },
    // Finance
    getAzDistributorsFinance(state)                                   { return state.azDistributorsFinance },
    getAzDistributorsFinanceDetailsPaymentOrder(state)                { return state.azDistributorsFinance.paymentOrder },
    getAzDistributorsFinanceDetailsAccountHolder(state)               { return state.azDistributorsFinance.accountHolder },
    getAzDistributorsFinanceDetailsPaymentTarget(state)               { return state.azDistributorsFinance.paymentTarget },
    getAzDistributorsFinanceDetailsVatId(state)                       { return state.azDistributorsFinance.vatId },
    getAzDistributorsFinanceDetailsIban(state)                        { return state.azDistributorsFinance.iban },
    getAzDistributorsFinanceDetailsAccountNumber(state)               { return state.azDistributorsFinance.accountNumber },
    getAzDistributorsFinanceDetailsVatRetail(state)                   { return state.azDistributorsFinance.vatRetail },
    getAzDistributorsFinanceDetailsVatLicense(state)                  { return state.azDistributorsFinance.vatLicense },
    getAzDistributorsFinanceDetailsTaxOffice(state)                   { return state.azDistributorsFinance.taxOffice },
    getAzDistributorsFinanceDetailsBic(state)                         { return state.azDistributorsFinance.bic },
    getAzDistributorsFinanceDetailsRegistrationNumber(state)          { return state.azDistributorsFinance.registrationNumber },
    getAzDistributorsFinanceDetailsTaxIdNumber(state)                 { return state.azDistributorsFinance.taxIdNumber },
    getAzDistributorsFinanceDetailsBankName(state)                    { return state.azDistributorsFinance.bankName },
    getAzDistributorsFinanceDetailsRegisterCourt(state)               { return state.azDistributorsFinance.registerCourt },
    getAzDistributorsFinanceDetailsTaxNumber(state)                   { return state.azDistributorsFinance.taxNumber },
    getAzDistributorsFinanceDetailsTaxWaiver(state)                   { return state.azDistributorsFinance.taxWaiver },
    getAzDistributorsFinanceDetailsTaxWaiverFrom(state)               { return state.azDistributorsFinance.taxWaiverFrom },
    getAzDistributorsFinanceDetailsTaxWaiverTo(state)                 { return state.azDistributorsFinance.taxWaiverTo },
    getAzDistributorsFinanceDetailsTaxLiabilityPercentage(state)      { return state.azDistributorsFinance.taxLiabilityPercentage },
    getAzDistributorsFinanceDetailsPublishingStatementsText(state)    { return state.azDistributorsFinance.publishingStatementsText },
    getAzDistributorsFinanceDetailsLabelStatementsText(state)         { return state.azDistributorsFinance.labelStatementsText },    
}

const mutations = { 
    setAzDistributors:                      (state, distributorsFromDB) => { state.distributors = distributorsFromDB },
    setSelectedAzDistributors:              (state, selected) => { state.selectedAzDistributors = selected },
    setAzDistributorsSearch:                (state, search) => { state.azDistributorsSearch = search },
    setSelectedAzDistributorsVisibilityFilter: (state, value) => { state.selectedAzDistributorsVisibilityFilter = value },
    setIsAllSelectedAzDistributors:         (state, isSelected) => { state.isAllSelectedAzDistributors = isSelected },
    setExpandedAzDistributors:              (state, item)   => { state.expandedAzDistributors = [item] },
    // Details
    setAzDistributorsDetails:                    (state, item)   => { state.azDistributorsDetails = item },
    setAzDistributorsDetailsAlvId:               (state, alvId)  => { state.azDistributorsDetails.alvId = alvId },
    setAzDistributorsDetailsDistributor:         (state, name)   => { state.azDistributorsDetails.name = name },
    setAzDistributorsDetailsAddressRowOne:       (state, adress) => { state.azDistributorsDetails.addressRow1 = adress },
    setAzDistributorsDetailsAddressRowTwo:       (state, adress) => { state.azDistributorsDetails.addressRow2 = adress },
    setAzDistributorsDetailsZip:                 (state, zip)    => { state.azDistributorsDetails.zip = zip },
    setAzDistributorsDetailsCity:                (state, city)   => { state.azDistributorsDetails.city = city },
    setAzDistributorsDetailsCountry:             (state, country)=> { state.azDistributorsDetails.country = country },
    setAzDistributorsDetailsFullShippingAddress: (state, adress) => { state.azDistributorsDetails.fullShippingAddress = adress },
    setAzDistributorsDetailsSalesCountry:        (state, country)=> { state.azDistributorsDetails.salesCountry = country },
    setAzDistributorsDetailsType:                (state, type)   => { state.azDistributorsDetails.type = type },
    setAzDistributorsDetailsVisibility:          (state, value)  => { state.azDistributorsDetails.visibility = value },
    setAzDistributorsDetailsNotes:               (state, value)  => { state.azDistributorsDetails.notes = value },
    setAzDistributorsDetailsShipmentNote:        (state, value)  => { state.azDistributorsDetails.shippingNote = value },
    // Metadata
    setAzDistributorsMetadata:                        (state, data) => { state.azDistributorsMetadata = data },
    setAzDistributorsMetadataDetailsCurrency:         (state, item) => { state.azDistributorsMetadata.currency = item },
    setAzDistributorsMetadataDetailsLanguage:         (state, item) => { state.azDistributorsMetadata.language = item },
    setAzDistributorsMetadataDetailsFoundingDate:     (state, item) => { state.azDistributorsMetadata.foundingDate = item },
    setAzDistributorsMetadataDetailsCustomerNumber:   (state, item) => { state.azDistributorsMetadata.customerNumber = item },
    setAzDistributorsMetadataDetailsTasFromPricelist: (state, item) => { state.azDistributorsMetadata.tasFromPricelist = item },
    setAzDistributorsMetadataDetailsWarehouseName:    (state, item) => { state.azDistributorsMetadata.warehouseName = item },
    setAzDistributorsMetadataDetailsReturnFee:        (state, item) => { state.azDistributorsMetadata.returnFee = item },
    setAzDistributorsMetadataDetailsReturnReserveCycle:(state, item)=> { state.azDistributorsMetadata.returnReserveCycle = item },
    setAzDistributorsMetadataDetailsReturnReservePercent:(state, item) => { state.azDistributorsMetadata.returnReservePercent = item },
    setAzDistributorsMetadataDetailsFocFirstShipment: (state, item) => { state.azDistributorsMetadata.focFirstShipment = item },
    setAzDistributorsMetadataDetailsFocAllShipments:  (state, item) => { state.azDistributorsMetadata.focAllShipments = item },
    setAzDistributorsMetadataDetailsHandlingFee:     (state, item) => { state.azDistributorsMetadata.handlingFee = item }, 
    setAzDistributorsMetadataDetailsDistributorReturnFee:(state, item) => { state.azDistributorsMetadata.returnFee = item }, 
    // Finance
    setAzDistributorsFinance:                             (state, item)   => { state.azDistributorsFinance = item },
    setAzDistributorsFinanceDetailsPaymentOrder:          (state, item)   => { state.azDistributorsFinance.paymentOrder = item },
    setAzDistributorsFinanceDetailsAccountHolder:         (state, item)   => { state.azDistributorsFinance.accountHolder = item },
    setAzDistributorsFinanceDetailsPaymentTarget:         (state, item)   => { state.azDistributorsFinance.paymentTarget = item },
    setAzDistributorsFinanceDetailsVatId:                 (state, item)   => { state.azDistributorsFinance.vatId = item },
    setAzDistributorsFinanceDetailsIban:                  (state, item)   => { state.azDistributorsFinance.iban = item },
    setAzDistributorsFinanceDetailsVatRetail:             (state, item)   => { state.azDistributorsFinance.vatRetail = item },
    setAzDistributorsFinanceDetailsVatLicense:            (state, item)   => { state.azDistributorsFinance.vatLicense = item },
    setAzDistributorsFinanceDetailsTaxOffice:             (state, item)   => { state.azDistributorsFinance.taxOffice = item },
    setAzDistributorsFinanceDetailsBic:                   (state, item)   => { state.azDistributorsFinance.bic = item },
    setAzDistributorsFinanceDetailsRegistrationNumber:    (state, item)   => { state.azDistributorsFinance.registrationNumber = item },
    setAzDistributorsFinanceDetailsTaxIdNumber:           (state, item)   => { state.azDistributorsFinance.taxIdNumber = item },
    setAzDistributorsFinanceDetailsBankName:              (state, item)   => { state.azDistributorsFinance.bankName = item },
    setAzDistributorsFinanceDetailsRegisterCourt:         (state, item)   => { state.azDistributorsFinance.registerCourt = item },
    setAzDistributorsFinanceDetailsTaxNumber:             (state, item)   => { state.azDistributorsFinance.taxNumber = item },
    setAzDistributorsFinanceDetailsTaxWaiver:             (state, item)   => { state.azDistributorsFinance.taxWaiver = item },
    setAzDistributorsFinanceDetailsTaxWaiverFrom:         (state, item)   => { state.azDistributorsFinance.taxWaiverFrom = item },
    setAzDistributorsFinanceDetailsTaxWaiverTo:           (state, item)   => { state.azDistributorsFinance.taxWaiverTo = item },
    setAzDistributorsFinanceDetailsTaxLiabilityPercentage:(state, item)   => { state.azDistributorsFinance.taxLiabilityPercentage = item },
    setAzDistributorsFinanceDetailsPublishingStatementsText:(state, item) => { state.azDistributorsFinance.publishingStatementsText = item },
    setAzDistributorsFinanceDetailsLabelStatementsText:   (state, item)   => { state.azDistributorsFinance.labelStatementsText = item },
}

const actions = {
// FETCH Distributors
    async fetchAzDistributors( { commit, getters }) {  
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'search' : getters.getAzDistributorsSearch,
            'visibility': getters.getSelectedAzDistributorsVisibilityFilter,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setAzDistributors', [])
        } else {
            commit('setAzDistributors', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },
    
    // Fetch Details for a specific Distributor     
    async fetchAzDistributorsDetails({ commit, getters, dispatch }, alvId) {
        let values
        let response = await api.getDetailsById(DIR, alvId) 
        if(response === undefined || response.length === 0 || response.error === 1) {
            values = {}
        } else {
            let shippingAddress = ""
                if (response.fullShippingAddress != null)
                    shippingAddress = response.fullShippingAddress
                if (router.currentRoute.name == "AzDistributorsEdit")
                    shippingAddress = shippingAddress.replace(/<br\s*[\/]?>/gi, "\n")
                response.fullShippingAddress = shippingAddress
                values = response
        }
    
        commit('setAzDistributorsDetails', values)
        dispatch('fetchAzDistributorsMetadata')
        dispatch('fetchAzDistributorsFinance')
        commit('setIsLoading', false)
    },

    // FETCH METADATA
    async fetchAzDistributorsMetadata({ getters, commit }) {
        let metadataFromDB = getters.getAzDistributorsDetails.metadata
        commit('setAzDistributorsMetadata', metadataFromDB)
    },
    // FETCH FINANCE
    async fetchAzDistributorsFinance({ getters, commit }) {
        let financeFromDB = getters.getAzDistributorsDetails.finance
        commit('setAzDistributorsFinance', financeFromDB)
    },

    // SAVE
    async saveAzDistributorsForm({ commit, getters, dispatch }) {
        let alvId = getters.getAzDistributorsDetailsAlvId
        let metaData = getters.getAzDistributorsDetails

        let response = await api.saveEditForm(DIR, alvId, metaData, false)   
    
        if(response === undefined || response.length === 0 || response.error === 1) { 
            let errorMessages = response.response.errorMsg
            let errorMessageForSnackbar = i18n.t('lang_GENERIC_SNACKBAR_SAVING_NOT_SUCCESSFUL')

            errorMessages.forEach(msg => {
                errorMessageForSnackbar += '<br />' + i18n.t(msg)
            })

            commit('setSnackbar', {
                type: 'error',
                msg: errorMessageForSnackbar
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL')
            })

            dispatch('fetchAzDistributorsDetails', router.currentRoute.params.alvId)
            dispatch("updateListOfDistributorsInLocalStorage")
        }
    },
    
    /**
     * 
     * Method is updating the list of distributors
     * in Label => Statistics => In Row Dropdown => Distributors 
     */
    updateListOfDistributorsInLocalStorage({ getters }){
        /**
         * Declaring: 
         *  - Local Storage Object
         *  - Details of the saved distributor 
         *  - List of distributors sent from BE to Local Storage
         */
        let savedDistributorDetails = getters.getAzDistributorsDetails
        let localStorageData = JSON.parse(localStorage.getItem("userData"))
        let distributorsListFromLS = localStorageData.labelStatisticsInRows.distributors

        // Case 1: If the visibility of the distributor was changed to "Visible"
        if(savedDistributorDetails.visibility === 2){
            //Searching for previously saved person in the list of visible distributors in Local Storage
            let matchVisible = distributorsListFromLS.find(distributor => {
                return distributor.alvid === savedDistributorDetails.alvId
            })

            //If the saved distributor was found nothing will be done
            if(matchVisible !== undefined && matchVisible !== null){
                console.log("Visible: Already in the list in LS");
            }else{
                /**
                 *   Otherwise:
                 *      - Distributor was not in the list that was sent from BE to Local Storage
                 *      - Creating a new object with the required data for the Distributors list in Local storage
                 *      - Pushing new Object (Visible Distributor) to the list of visible distributors in Local Storage
                 *      - Updating the local storage information 
                 * */
                
                let newObj = {
                    value: savedDistributorDetails.id, 
                    text: savedDistributorDetails.name, 
                    alvid: savedDistributorDetails.alvId
                }
                localStorageData.labelStatisticsInRows.distributors.push(newObj)
                localStorage.setItem("userData",JSON.stringify(localStorageData))

            }
        }else
        // Case 2: If the visibility of the distributor was changed to "Hidden"
        {
            //Searching for an saved distributor in the list of visible distributors in Local Storage
            let matchHidden = distributorsListFromLS.find(distributor => {
                return distributor.alvid === savedDistributorDetails.alvId
            })

            /**
             * If the distributor was found in the list of distributors in Local Storage:
             *  - Finding index of the newly saved distributor in the list of distributors in Local Storage
             *  - Removing the distributor from the list of visible distributors in Local Storage
             *  - Updating the information in Local Storage
             */
            if(matchHidden !== undefined && matchHidden !== null){
                console.log("Hidden: Already in the list in LS");
                
                let indexOfDistributorToRemove = localStorageData.labelStatisticsInRows.distributors.findIndex(distributor =>{
                    return distributor.alvid === matchHidden.alvid
                })
                localStorageData.labelStatisticsInRows.distributors.splice(indexOfDistributorToRemove,1)
                localStorage.setItem("userData",JSON.stringify(localStorageData))

            }else{
                //The distributor with the Visibility status "Hidden" was not in the list of visible distributors in Local Storage
                // => Do nothing 
                console.log("Hidden: Was not found");
            }
        }
    }


}

export default {
    state, getters, actions, mutations
}